(() => {
  function init(root) {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const cards = [...root.querySelectorAll('[data-xc-product]')];
    const buttons = [...root.querySelectorAll('[data-xc-filter]')];
    const result = root.querySelector('[data-xc-results]');
    const basket = root.querySelector('[data-xc-basket]');
    const filter = (kind) => {
      let count = 0;
      cards.forEach(card => {
        const show = kind === 'all' || (kind === 'vegan' ? card.dataset.vegan === 'true' : card.dataset.kind === kind);
        card.hidden = !show;
        if (show) count++;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.xcFilter === kind)));
      if (result) result.textContent = `${count} ${root.dataset.count}`;
    };
    buttons.forEach(button => button.addEventListener('click', () => filter(button.dataset.xcFilter)));
    root.querySelectorAll('[data-xc-preset]').forEach(link => link.addEventListener('click', () => filter(link.dataset.xcPreset)));
    const filters = root.querySelector('[data-xc-filters]');
    if (filters) filters.hidden = false;
    root.querySelectorAll('.xc-product-form').forEach(form => {
      const card = form.querySelector('[data-xc-card]');
      const toggleCard = () => form.querySelectorAll('[data-xc-card-extra]').forEach(input => { input.disabled = !card.value; });
      card.addEventListener('change', toggleCard);
      toggleCard();
      const variant = form.querySelector('[data-xc-variant]');
      const add = form.querySelector('[data-xc-add]');
      if (variant) variant.addEventListener('change', () => {
        const option = variant.selectedOptions[0];
        form.closest('[data-xc-product]').querySelector('[data-xc-price]').textContent = option.dataset.price;
        add.disabled = option.dataset.available !== 'true';
        add.textContent = add.disabled ? root.dataset.soldOut : root.dataset.add;
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (add.disabled || !form.reportValidity()) return;
        const status = form.querySelector('[data-xc-status]');
        const data = new FormData(form);
        if (!card.value) data.delete('properties[Greeting card]');
        add.disabled = true;
        add.textContent = root.dataset.adding;
        status.textContent = '';
        status.classList.remove('xc-error');
        let added = false;
        try {
          const response = await fetch(root.dataset.addUrl, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
          const line = await response.json();
          if (!response.ok) throw new Error(line.description || root.dataset.error);
          added = true;
          if (typeof window.refreshCart === 'function') window.refreshCart();
          status.textContent = root.dataset.added;
          basket.hidden = false;
          basket.querySelector('[data-xc-basket-status]').textContent = root.dataset.added;
          try {
            const cartResponse = await fetch(root.dataset.cartUrl, { headers: { Accept: 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              basket.querySelector('[data-xc-cart-count]').textContent = cart.item_count;
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            }
          } catch (_) { /* The addition succeeded; View cart remains available. */ }
        } catch (error) {
          status.classList.add('xc-error');
          status.textContent = error.message || root.dataset.error;
        } finally {
          add.disabled = variant ? variant.selectedOptions[0].dataset.available !== 'true' : false;
          add.textContent = add.disabled ? root.dataset.soldOut : root.dataset.add;
          if (added) add.setAttribute('aria-label', root.dataset.add);
        }
      });
    });
  }
  document.querySelectorAll('[data-xc-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-xc-root]').forEach(init));
})();
